import styled from 'styled-components';

export const InsuranceWrap = styled.section`
  padding: 1.25rem 2rem 2rem 2rem;
`;
export const InsuranceTitle = styled.div(
  props => `
    font-size: 1.6rem;
    font-weight: bold;
    font-family:${props.theme.font.fontFamily};
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 0 0.5rem;
`,
);

export const InsuranceType = styled.div`
  display: flex;
  flex-direction: row;
  padding: 2rem 0 3rem 0;
`;
export const InsTypeList = styled.div`
  width: 15rem;
  align-items: center;
  justify-content: space-between;
  display: flex;
  flex-direction: column;
  padding: 0 2rem 0 0;
  min-height: 12rem;
`;
export const InsTypeTxt = styled.p`
  font-size: 1.4rem;
  padding: 1rem 0;
  text-align: center;
  display: flex;
  flex-wrap: wrap;

`;
export const InsTypeTag = styled.div`
  border-radius: 1rem;
  background-image: linear-gradient(80deg, #00c57e, #18a160);
  padding: 0.2rem 0.5rem;
  color: white;
  font-weight: bold;
  font-size: 1.2rem;
  text-align: center;
  width: 100%
`;

export const RadioButton = styled.label`
  display: inline-flex;
  position: relative;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  margin-right: 3rem;
  user-select: none;
  .checkmark {
    position: relative;
    display: flex;
    height: 2rem;
    width: 2rem;
    background-color: white;
    border-radius: 50%;
    border: 2px solid #2276e3;
    margin-right: 1.5rem;
    &:after {
      display: none;
      content: '';
      position: absolute;
      top: 50%;
      left: 50%;
      width: 1.1rem;
      height: 1.1rem;
      border-radius: 50%;
      background: #2276e3;
      transform: translate(-50%, -50%);
    }
  }
  .radioLabel {
    font-size: 1.4rem;
    color: black;
    font-weight: bold;
  }
  input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    &:checked ~ .checkmark {
      background-color: white;
      &:after {
        display: block;
      }
    }
  }
`;




export const CheckboxWrap = styled.div`
  display: flex;
  flex-direction: column;
  ${RadioButton} {
    margin-bottom: 2rem;
  }
`;

export const RequiredTxt = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;
export const RequiredTag = styled.div`
  border-radius: 0.2rem;
  padding: 0.2rem 0.5rem;
  color: white;
  font-size: 1.2rem;
  font-weight: bold;
  margin-right: 1rem;
  .bg-blue{
    background-color: #2276E3;
  }
  .bg-red{
    background-color: #ff3a5c;
  }
`;
export const Persuation = styled.div`
  border-radius: 0.2rem;
  background-color: #e9f6ea;
  color: #2bac36;
  font-size: 1.2rem;
  padding: 1rem;
`;
export const TagLoader = styled.p`
  display: flex;
  align-items: center;
  flex-direction: row;
  padding-left:1rem;

  span {
    font-size: 1.2rem;
    color: #2276e3;
    padding-left: 0.5rem;
  }
`;
export const AppliedTag = styled.p`
  background: #e9f6ea;
  color: #2bac36;
  display: flex;
  flex-direction: row;
  align-items: center;
  border-radius: 0.3rem;
  padding: 0.8rem;
  cursor:pointer;
  margin-left:1rem
`;
export const CloseIcon = styled.span`
  background: #2bac36;
  color: #e9f6ea;
  width: 1.2rem;
  height: 1.2rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1rem;
  font-weight: bold;
  margin-left: 0.5rem;
`;